import React from 'react';

import {
  ISlideTransitionProps,
  SlideTransition,
} from '../../../../utils/slide-transition/SlideTransition';
import { useHistoryStack } from '../../../history-stack';

interface ITransitionProps {
  classes?: ISlideTransitionProps['classes'];
}

export const Transisition: React.FC<ITransitionProps> = (props) => {
  const { direction, current, currentStackIndex } = useHistoryStack();

  return (
    <SlideTransition
      classes={props.classes}
      currentKey={current ? currentStackIndex.toString() : 'no-view'}
      direction={direction}
    >
      {props.children}
    </SlideTransition>
  );
};
